import { useCallback, useMemo } from "react";
import { mutate } from "swr";

import {
  applicationEndPoints,
  organizationApplicationEndpoints
} from "@api/Endpoints";
import { deleteData } from "@hooks/useDeleteData";

export function useDisassociateApplication() {
  const remove = useCallback(
    async (organizationId: string, applicationId: string) => {
      const url = applicationEndPoints.disassociate(
        applicationId,
        organizationId
      );
      const result = await deleteData(url);
      const getUrl = organizationApplicationEndpoints.get(organizationId);
      await mutate(getUrl);
      return result;
    },
    []
  );
  return useMemo(() => ({ remove }), [remove]);
}
